import { error, request, success } from 'store/api/actions';
import { baseApi } from 'store/api/apiRequestBuilder';
import actionTypes from 'store/nft/actionTypes';
import { call, put, takeLatest } from 'typed-redux-saga';
import { camelize, logger } from 'utils';

import { getFavorites } from '../actions';
import { setFavorites } from '../reducer';

export function* getFavoritesSaga({ type }: ReturnType<typeof getFavorites>) {
  yield* put(request(type));

  try {
    const { data } = yield* call(baseApi.getFavorites);

    yield* put(setFavorites(camelize(data)));

    yield* put(success(type));
  } catch (e) {
    yield* put(error(type, e));
    logger('getFavoritesSaga', e);
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.GET_FAVORITES, getFavoritesSaga);
}
